
<template>
  <div>
    <el-button
      type="primary"
      size="small"
      icon="el-icon-plus"
      v-permission="Auth.productGroupAddRecord"
      @click="handleAdd()"
      >添加使用记录</el-button
    >
    <el-table :data="list" border size="small" class="mt-10">
      <el-table-column align="center" label="上报时间" prop="created_at_human">
        <template slot-scope="scope">
          {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="上报人" prop="user_name">
      </el-table-column>
      <el-table-column align="center" label="成品分类" prop="product.name">
      </el-table-column>
      <el-table-column
        align="center"
        label="成品编号/仪器串"
        prop="product.code"
      >
        <template slot-scope="scope">
          <ProductLink :product="scope.row.product"></ProductLink>
          <el-popover
            v-if="scope.row.product_group_id"
            placement="left"
            :title="'仪器串：' + scope.row.product_group.name"
            width="400"
            trigger="click"
          >
            <div>
              <div style="display: flex; gap: 5px; flex-wrap: wrap">
                <el-tag
                  size="mini"
                  v-for="item in scope.row.product_group.product_names.split(
                    ',',
                  )"
                  :key="item"
                  >{{ item }}</el-tag
                >
              </div>
            </div>
            <el-button
              slot="reference"
              type="text"
              size="mini"
              style="color: #999"
              >{{ scope.row.product_group.name }}</el-button
            >
          </el-popover>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="操作类型" prop="category_name">
      </el-table-column> -->
      <el-table-column align="left" label="上报数据" min-width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.usage">趟钻数：第{{ scope.row.usage }}趟</div>
          <div v-if="scope.row.used_date">
            使用日期：{{ $time(scope.row.used_date).format('YYYY-MM-DD') }}
            <el-button
              type="text"
              size="mini"
              v-permission="Auth.productGroupAddRecord"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
          </div>
          <div v-if="scope.row.up_well_time">
            钻进周期：{{ scope.row.down_well_time }}时 ~
            {{ scope.row.up_well_time }}时
          </div>
          <div v-if="scope.row.used_hour">
            工作时长：{{ scope.row.used_hour }}
          </div>
          <div
            v-if="scope.row.up_reason"
            v-html="'起钻原因：' + scope.row.up_reason"
          ></div>
          <div
            v-if="scope.row.malfunction"
            v-html="'故障描述：' + scope.row.malfunction"
          ></div>
          <!-- <div v-if="scope.row.used_extra">
            <div v-for="param in scope.row.used_extra" :key="param.key">
              {{ param.label }}：{{ param.value }}
            </div>
          </div> -->
          <div v-html="scope.row.remark"></div>
          <div class="medio-container">
            <el-image
              v-for="url in scope.row.imgs"
              :key="url"
              style="width: 30px; height: 30px; margin-right: 5px"
              :src="url"
              :preview-src-list="scope.row.imgs"
            >
            </el-image>
            <VideoPlayer :srcs="scope.row.videos"></VideoPlayer>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        align="center"
        label="操作基地"
        prop="base.name"
      ></el-table-column> -->
    </el-table>

    <ProductRecordFormer
      :wellid="wellId"
      :model="model"
      :show.sync="dialogVisible"
      @created="getData"
    ></ProductRecordFormer>
  </div>
</template>

<script>
import { productRecordList } from '@/service/getData'
import { urlPerfix } from '@/config/env'
import store from '@/store/index'
import ProductRecordFormer from './ProductRecordFormer.vue'

export default {
  components: {
    ProductRecordFormer,
  },
  props: {
    wellId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      actionUrl: urlPerfix + '/files/upload',
      userInfo: store.state.userInfo,
      uploadHeader: { Token: store.state.userInfo.token },
      model: {},
      dialogVisible: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await productRecordList({
        drill_well_id: this.wellId,
        page: 0,
        size: 100,
      })
      this.list = res.data.list
    },
    handleAdd(groupid = '') {
      this.model = {
        drill_well_id: this.wellId,
        product_group_id: groupid,
        usage: '',
        used_date: '',
        down_well_time: '',
        up_well_time: '',
        used_hour: 0,
        up_reason: '',
        malfunction: '',
        remark: '',
        remarks: [],
        imgs: [],
        videos: [],
      }
      this.dialogVisible = true
    },
    handleEdit(item) {
      this.model = this.clone(item)
      this.dialogVisible = true
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    handleOnSuccess(res, file) {
      this.getData()
    },
  },
}
</script>